module.exports = __webpack_public_path__ + "img/Blog-Image.7d1e209c.png";